import { createContext, useContext } from "react";
import { useBackofficeHome } from "./useBackofficeHome.js";

const BackofficeIdentityContext = createContext(null);

/**
 * Fetches GET /api/backoffice/home once per guarded page view and shares it
 * with both the page content (e.g. the SuperAdmin dashboard) and the shared
 * Sidebar's "signed in as" footer, so the sidebar never needs its own
 * duplicate fetch just to show the current role.
 */
export function BackofficeIdentityProvider({ children }) {
  const identity = useBackofficeHome();
  return (
    <BackofficeIdentityContext.Provider value={identity}>{children}</BackofficeIdentityContext.Provider>
  );
}

/** Read the shared { status, data, error } home-identity fetch. */
export function useBackofficeIdentity() {
  const value = useContext(BackofficeIdentityContext);
  if (!value) {
    throw new Error("useBackofficeIdentity must be used within BackofficeIdentityProvider");
  }
  return value;
}
